import { render, staticRenderFns } from "./ModalImportarProcedimentos.vue?vue&type=template&id=c7fcd394&scoped=true"
import script from "./ModalImportarProcedimentos.vue?vue&type=script&lang=ts"
export * from "./ModalImportarProcedimentos.vue?vue&type=script&lang=ts"
import style0 from "./ModalImportarProcedimentos.vue?vue&type=style&index=0&id=c7fcd394&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7fcd394",
  null
  
)

export default component.exports